/*
Sohel 11/02/2022 2699761741 Added Search Event Tactic Form
Sohel 11/02/2022 2699823790 reset Trigger get data and fetch dropdown data
Sohel 11/03/2022 2699823790 event Type Dropdown value changes
Rajesh 11/15/2022 2699823790 passing props to conditionally render add trigger button.
Rajesh 11/15/2022 2699823790 passing props for search Table.
Prakash 11/16/2022 2699823790 Fixed overflow in Dialogbox.
Rajesh 11/16/2022 2699823790 passing props for search Table.
Sohel 11/14/2022 2699818958 Implemented run functionality
Prakash 11/21/2022 2699823790 Added conditional for dialogbox screen.
Prakash 11/22/2022 2699823790 Fixed Responsiveness Issues.
Sohel 11/22/2022 2699818958 fixed search Table reset Issue
Akhila 11/24/2022 2699818958 rename the field label
Guru Prasad 11/24/2022 2699823790 Fixed input field and button alignments.
Akhila 11/25/2022 2699823790 textfield PlaceHolder name change
saikrishna 11/29/2022 2699818958 Removed Codes in event type dropdown.
Suresh peddavoora 11/30/2022 2699818958 Fixed Text Fields Responsive Issue.
lalitha 12/09/2022 2699818958 Added Created Date Field

akhila 12/08/2022 2699818958 adding session storage for search items
Raghu 12/09/2022 2699818958 Field alignment fixes
Raghu 12/12/2022 2699818958 Buttons resposnive alignment fixes
Prakash Gummala 12/20/2022 2699818958 button Alignments for tab resolution.
Dilip 12/30/2022 2699818958 renamed labels for code and description
Dilip 02/09/2023 2699818958 added created by dropdown
Raghu 02/21/2023 2699818958 changed text feilds colors
Prakash 03/28/2023 2699818958 fixed input filed issue.
Prakash 08/05/2023 2699761741 add theming classname.
Akhila 06/08/2023 2699761741 created date change to date created field and column
Sohel 11/12/2023 2699761741 Added validation for EventCode and Event Description in EventTriggers
*/
import React, {useContext, useState} from 'react';
import {useForm} from 'react-hook-form';
import {TextField, FormControl, Button, FormHelperText} from '@material-ui/core';
import {Controller} from 'react-hook-form';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {getDropDownData} from '../../../../redux/reducers/TriggerGroup';
import {getOptions} from './../../../../util/GetDropDownOptions';
import {EVENT_TYPE_TRIGGER} from '../../../../constants/Lookup';
import SearchTable from './SearchTable';
import {useSelector, useDispatch} from 'react-redux';
import {useEffect} from 'react';
import {
  resetTriggerGroupData,
  postRunTrigger,
} from '../../../../redux/reducers/EventTriggerGroup';
import {fetchDispositionCodes} from '../../../../redux/reducers/EventTactics/EventTactics';
import ConfirmationForm from '../../Triggers/SearchTrigger/ConfirmationForm';
import DialogBox from './../../../../components/DialogBox';
import {
  getAllReportCreatedForData,
  fetchCreatedByDropDownData,
} from '../../../../redux/reducers/ReportMaster';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import {yupResolver} from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {createdByOptions} from '../../../../util/CreatedByForOptions';

export default function SearchTriggerGroup({
  setValue,
  nightJobSearchTrigger,
  setTriggerSearchCode,
  setSearchTrigger,
}) {
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const [runClicked, setRunClicked] = useState(false);
  const dispatch = useDispatch();
  const {dispositionDropDown} = useSelector(({addEventTactic}) => addEventTactic);
  const {createdByData} = useSelector(({reportMaster}) => reportMaster);
  const closeDialog = () => {
    setRunClicked(false);
  };
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  const SearchSessionEvent = JSON.parse(sessionStorage.getItem('EventTriggerGroup'));
  const initialValues = {
    code: '',
    description: '',
    eventType: null,
    fieldValue: '',
    createdBy: '',
    createdDate: null,
  };
  const {
    handleSubmit,
    control,
    reset,
    errors,
    setValue: setFieldValue,
  } = useForm({
    mode: 'all',
    defaultValues: SearchSessionEvent ? SearchSessionEvent : initialValues,
    resolver: yupResolver(validationSchema),
  });
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [mainRunClicked, setMainRunClicked] = useState(false);
  const [rowData, setRowData] = useState({});
  const onSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
    sessionStorage.setItem('EventTriggerGroup', JSON.stringify(data));
  };
  const onClear = () => {
    const data = {
      code: '',
      description: '',
      eventType: null,
      fieldValue: '',
      createdBy: '',
      createdDate: null,
    };
    setSearchData(data);
  };
  useEffect(() => {
    dispatch(getDropDownData());
    dispatch(resetTriggerGroupData());
    dispatch(fetchDispositionCodes());
  }, []);

  useEffect(() => {
    dispatch(fetchCreatedByDropDownData('eventtrigger'));
  }, [dispatch]);

  useEffect(() => {
    if (mainRunClicked) {
      dispatch(
        postRunTrigger({
          groupCode: rowData?.groupCode ? rowData?.groupCode : '',
        }),
      );
      setRowData('');
      setMainRunClicked(false);
    }
  }, [mainRunClicked, rowData]);
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
  }, []);
  return (
    <div className={nightJobSearchTrigger ? 'col-12' : ''}>
      <h2 className="search-title">Event Triggers Search</h2>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="form-row new-standard-textfields align-items-center">
          <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group account-guarantor">
            <FormControl variant="outlined" fullWidth>
              <Controller
                render={({value, onChange}) => (
                  <TextField
                    className={`${classes.labelName}`}
                    placeholder="Enter Event Trigger Name"
                    margin="dense"
                    name="code"
                    variant="outlined"
                    label="Event Trigger Name"
                    value={value}
                    onChange={onChange}
                    error={Boolean(errors.code?.message)}
                    fullWidth
                  />
                )}
                control={control}
                name="code"
              />
            </FormControl>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group account-guarantor">
            <FormControl variant="outlined" fullWidth>
              <Controller
                render={({value, onChange}) => (
                  <TextField
                    className={`${classes.labelName}`}
                    placeholder="Enter Event Trigger Description"
                    margin="dense"
                    name="description"
                    variant="outlined"
                    label="Event Trigger Description"
                    value={value}
                    onChange={onChange}
                    error={Boolean(errors?.description?.message)}
                    fullWidth
                  />
                )}
                control={control}
                name="description"
              />
            </FormControl>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group account-guarantor">
            <FormControl margin="dense" variant="outlined" fullWidth>
              <Controller
                render={(props) => (
                  <GuiAutoComplete
                    {...props}
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    id="eventType"
                    size="small"
                    autoHighlight
                    options={getOptions(EVENT_TYPE_TRIGGER, dispositionDropDown)}
                    getOptionDisabled={(option) => option.valueCode === 'none'}
                    getOptionLabel={(option) => {
                      return option && option.value ?
                        option.valueCode === null ?
                          option.value :
                          option.value :
                        '';
                    }}
                    renderInput={(params) => (
                      <GuiTextField
                        className={`${classes.labelName}`}
                        {...params}
                        variant="outlined"
                        fullWidth
                        label="Event Type"
                        name="eventType"
                        error={Boolean(errors?.eventType?.message)}
                        placeholder="Select Event Type"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'off',
                        }}
                      />
                    )}
                    onChange={(_, data) => {
                      props.onChange(data);
                    }}
                  />
                )}
                name="eventType"
                control={control}
              />
            </FormControl>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group account-guarantor">
            <FormControl variant="outlined" fullWidth>
              <Controller
                render={({value, onChange}) => (
                  <TextField
                    className={`${classes.labelName}`}
                    placeholder="Enter Value"
                    margin="dense"
                    name="fieldValue"
                    variant="outlined"
                    label="Value"
                    value={value}
                    onChange={onChange}
                    error={Boolean(errors?.fieldValue?.message)}
                    fullWidth
                  />
                )}
                control={control}
                name="fieldValue"
              />
            </FormControl>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group account-guarantor">
            <Controller
              render={({onChange, value}) => (
                <GuiAutoComplete
                  classes={{
                    option: classes.option,
                  }}
                  id="createdBy"
                  size="small"
                  options={createdByData}
                  value={value}
                  getOptionLabel={(option) => {
                    return option && option?.userLoginName ? option?.userLoginName : '';
                  }}
                  renderOption={(option) => {
                    return createdByOptions(option);
                  }}
                  onChange={(_, data) => {
                    onChange(data);
                  }}
                  renderInput={(params) => (
                    <div className="select-field">
                      <GuiTextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        label="Created By"
                        className={`${classes.labelName}`}
                        placeholder="Select Created By"
                      />
                    </div>
                  )}
                />
              )}
              name="createdBy"
              control={control}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group account-guarantor start-enddate">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({value}) => (
                    <KeyboardDatePicker
                      className={`${classes.labelName}`}
                      orientation="portrait"
                      format="MM/dd/yyyy"
                      value={value}
                      autoOk
                      inputVariant="outlined"
                      margin="dense"
                      placeholder="MM/DD/YYYY"
                      fullWidth
                      label="Date Created"
                      helperText={null}
                      error={Boolean(errors?.createdDate?.message)}
                      onChange={(date) => {
                        setFieldValue('createdDate', date);
                        return {value: date};
                      }}
                    />
                  )}
                  control={control}
                  name="createdDate"
                />
              </FormControl>
            </MuiPickersUtilsProvider>
            <FormHelperText variant="outlined">
              {errors?.createdDate?.message ? errors?.createdDate?.message : ''}
            </FormHelperText>
          </div>
          <div className="col-sm-6 col-lg-2 col-md-12 form-group">
            <div className="d-flex justify-content-md-center justify-content-lg-start">
              <Button
                type="button"
                onClick={() => {
                  reset(initialValues);
                  onClear();
                  setSubmit(true);
                  sessionStorage.removeItem('EventTriggerGroup');
                }}
                variant="outlined"
                className={`reset-btn mx-1 ${classes.buttonRoot}`}
              >
                Reset
              </Button>
              <Button
                type="submit"
                variant="outlined"
                className={`search-btn mx-1 ${classes.buttonRoot}`}
              >
                Search
              </Button>
            </div>
          </div>
        </div>
      </form>

      <div>
        <SearchTable
          nightJobSearchTrigger={nightJobSearchTrigger}
          searchData={searchData}
          setSearchData={setSearchData}
          submit={submit}
          setSubmit={setSubmit}
          setValue={setValue}
          setRunClicked={setRunClicked}
          setRowData={setRowData}
          setSearchTrigger={setSearchTrigger}
          setTriggerSearchCode={setTriggerSearchCode}
        />
      </div>
      <DialogBox
        open={runClicked}
        dialogClose={closeDialog}
        title="Run Event Trigger"
        fullWidth
        maxWidth={'sm'}
        classes={{paper: classes.dialogPaper}}
      >
        <ConfirmationForm closeDialog={closeDialog} setMainRunClicked={setMainRunClicked} />
      </DialogBox>
    </div>
  );
}
